export const RATE_LIST_REPORT_GO_BUTTON_ACTION = "RATE_LIST_REPORT_GO_BUTTON_ACTION";
export const RATE_LIST_REPORT_GO_BUTTON_SUCCESS = "RATE_LIST_REPORT_GO_BUTTON_SUCCESS";
export const RATE_LIST_REPORT_API_ERROR_ACTION = "RATE_LIST_REPORT_API_ERROR_ACTION";
